var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"administration-tabs"},_vm._l((_vm.tabs),function(label,idx){return _c('button',{key:idx,staticClass:"administration-tabs__button",class:{ active: _vm.isActive(idx) },on:{"click":function($event){return _vm.setActive(idx)}}},[_vm._v(" "+_vm._s(label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }